import { use } from "react";
import { AuthContext } from "./AuthProvider";
import type { AuthContextValue } from "./types";

/**
 * Access authentication state and methods.
 * Must be used within an AuthProvider.
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
